import React, { useEffect, useRef, useState } from "react";
import "./Customisation_Form.css";
import { Form, Row, Table } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import PhoneInput from "react-phone-input-2";
import { RegxExpression, Website_Type } from "../../../../utils/common";
import Purple_Btn from "../../../common_components/common_btn/purple_btn/Purple_Btn";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Uploaded_img_holder from "../../../common_components/uploaded_img_holder/Uploaded_img_holder";
import { CustomizationForm } from "../../../../utils/luxuryapis/form/form";
import {
  getAllProduct,
  getAllProductWebsiteType,
} from "../../../../utils/apis/master/Master";
import { Select2Data } from "../../../../utils/api";
import Select from "react-select";
import Success_modal from "../../../common_components/success_modal/Success_modal";
const Customisation_Form = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // const showSecondForm = location?.state?.showSecondForm || false;
  const [showSecondForm, setShowSecondForm] = useState(false);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [modalShow, setModalShow] = React.useState(false);
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const onSubmit = async (data) => {
    const formData = new FormData();

    // formData.append("material_id", data?.material_id?.value);
    formData.append("product_id", data?.product_id?.value);
    // formData.append("category_id", data?.category_id?.value);
    formData.append("requirement", data?.requirement);
    formData.append("company_name", data?.company_name);
    // formData.append("image", data?.image[0]);
    formData.append("name", data?.name);
    formData.append("email", data?.email);
    formData.append("contact_no", data?.contact_no);
    if (uploadedImages.length > 0) {
      uploadedImages?.map((image, index) => {
        formData.append(`images[${index}]`, image.file);
      });
    }
    const res = await CustomizationForm(formData);
    if (res?.success) {
      reset();
      setUploadedImages([]);
      setModalShow(true);
      setTimeout(() => {
        setModalShow(false);
      }, 3000);
    } else {
    }
  };

  const [productdata, setProductdata] = useState();

  const GetAllProduct = async (id) => {
    const response = await getAllProductWebsiteType(Website_Type.Luxury);

    if (response?.success) {
      setProductdata(await Select2Data(response?.data, "product_id"));
    }
  };

  useEffect(() => {
    GetAllProduct();
  }, []);

  return (
    <section className="Customisation_Form">
      <div className="custom_container">
        <div className="main_div">
          {!showSecondForm ? (
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="form_div">
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row className="form_container">
                      {/* Name */}
                      <Form.Group className="input_group">
                        <Form.Label>Enter Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Name"
                          {...register("name", {
                            required: "Name is required",
                          })}
                          className={classNames({
                            "is-invalid": errors?.name,
                            "is-valid": getValues("name"),
                          })}
                        />
                        {errors?.name && (
                          <sup className="text-danger">
                            {errors?.name?.message}
                          </sup>
                        )}
                      </Form.Group>

                      {/* Email */}
                      <Form.Group className="input_group">
                        <Form.Label>Email Address</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Email Address"
                          {...register("email", {
                            required: "Email is required",
                            pattern: {
                              value: RegxExpression.email,
                              message: "Invalid email address",
                            },
                          })}
                          className={classNames({
                            "is-invalid": errors?.email,
                            "is-valid": getValues("email"),
                          })}
                        />
                        {errors?.email && (
                          <sup className="text-danger">
                            {errors?.email?.message}
                          </sup>
                        )}
                      </Form.Group>

                      {/* Contact */}
                      <Form.Group className="input_group">
                        <Form.Label>Contact*</Form.Label>
                        <Controller
                          name="contact_no"
                          control={control}
                          rules={{
                            required: "Field is required",
                          }}
                          render={({ field }) => (
                            <PhoneInput
                              country={"in"}
                              {...field}
                              className={classNames({
                                "is-invalid": errors?.contact_no,
                                "is-valid": getValues("contact_no"),
                              })}
                              onChange={(value) => field.onChange(value)}
                              placeholder="Enter Mobile Number"
                            />
                          )}
                        />
                        {errors?.contact_no && (
                          <sup className="text-danger">
                            {errors?.contact_no?.message}
                          </sup>
                        )}
                      </Form.Group>

                      {/* Upload Product */}
                      <Form.Group className="input_group">
                        <Form.Label>Add Product*</Form.Label>
                        <Controller
                          name="product_id" // name of the field
                          {...register("product_id", {
                            required: "Select Product",
                          })}
                          control={control}
                          render={({ field }) => (
                            <>
                              <Select
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors.product_id
                                      ? "red"
                                      : baseStyles,
                                  }),
                                }}
                                {...field}
                                options={productdata}
                              />
                            </>
                          )}
                        />

                        {errors.product_id && (
                          <span className="text-danger">
                            {errors.product_id.message}
                          </span>
                        )}
                      </Form.Group>

                      <hr />
                      <Form.Group className="input_group">
                        <Form.Label>Add Artwork / Image</Form.Label>
                        <Uploaded_img_holder
                          setUploadedImages={setUploadedImages}
                          uploadedImages={uploadedImages}
                        />
                      </Form.Group>

                      {/* Upload Notes */}
                      <div className="upload_note_div">
                        <p className="note_main_text">
                          UPLOAD YOUR DESIGN SAMPLE/S, SO THAT WE WILL GET TO
                          YOUR IDEA.
                        </p>
                        <p className="note_sub_text">
                          (Upload Preferences: 10 Mb Max PDF, AI, EPS, JPG, PNG,
                          JPEG)
                        </p>
                      </div>

                      <Form.Group className="input_group">
                        <Form.Label>Add Details</Form.Label>

                        <Form.Control
                          as="textarea"
                          name="requirement"
                          placeholder="Type Your Message Here..."
                          {...register("requirement", {
                            required: "requirement is required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.requirement,
                            "is-valid": getValues("requirement"),
                          })}
                        />

                        {errors.requirement && (
                          <span className="text-danger">
                            {errors.requirement.message}
                          </span>
                        )}
                      </Form.Group>

                      {/* Submit */}
                      <div className="btn-holder">
                        <Purple_Btn
                          btnText={"Submit Request"}
                          type="submit"
                          // onClick={() => setShowSecondForm(true)}
                        />
                      </div>
                    </Row>
                  </Form>
                </div>
              </div>

              {/* Right Image */}
              <div className="col-lg-4 col-md-6 col-sm-8">
                <div className="right_img_div">
                  <img
                    src="/assest/luxury_images/gift_customisation/right_img.png"
                    className="right_img"
                    alt="customisation"
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="row justify-content-center">
              <div className="col-lg-12">
                <div className="form_div">
                  <div className="row">
                    {/* Left Summary */}
                    <div className="col-md-4 ">
                      <div className="gift_right_summary">
                        <div className="img_holder">
                          <img
                            src="/assest/luxury_images/gifts/img1.png"
                            alt="product img"
                            className="product_img"
                          />
                        </div>

                        <div className="product_title_row">
                          <h2 className="product_title">
                            ODA Lapel Pin (Nickel)
                          </h2>
                          <p className="discount_text">30% Discount</p>
                        </div>

                        <div className="summary_table_holder">
                          <Table
                            responsive
                            className="summary_table"
                            borderless
                          >
                            <tbody>
                              <tr>
                                <td className="label">Color</td>
                                <td className="value">
                                  <div className="color_img_circle">
                                    <img
                                      src="/assest/luxury_images/gifts/img1.png"
                                      alt="color img"
                                      className="product_img"
                                    />
                                  </div>
                                </td>
                              </tr>

                              <tr>
                                <td className="label">Size</td>
                                <td className="value">
                                  <span className="strike_text">
                                    10.0000 (Grams)
                                  </span>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <div className="total_left">
                                    <p className="total_label">Total:</p>
                                  </div>
                                </td>
                                <td>
                                  <div className="total_right">
                                    <p className="mrp_text">MRP. ₹ 34560</p>
                                    <p className="selling_price">
                                      Selling Price: <span>₹ 2000</span>
                                    </p>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>

                    {/* Right Form */}
                    <div className="col-md-8 ">
                      <Form onSubmit={handleSubmit}>
                        <Row className="form_container">
                          {/* Name */}
                          <Form.Group className="input_group">
                            <Form.Label>Enter Name</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Name"
                              {...register("name", {
                                required: "Name is required",
                              })}
                              className={classNames({
                                "is-invalid": errors?.name,
                                "is-valid": getValues("name"),
                              })}
                            />
                            {errors?.name && (
                              <sup className="text-danger">
                                {errors?.name?.message}
                              </sup>
                            )}
                          </Form.Group>

                          {/* Email */}
                          <Form.Group className="input_group">
                            <Form.Label>Enter Email Address</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Email Address"
                              {...register("email", {
                                required: "Email is required",
                                pattern: {
                                  value: RegxExpression.email,
                                  message: "Invalid email address",
                                },
                              })}
                              className={classNames({
                                "is-invalid": errors?.email,
                                "is-valid": getValues("email"),
                              })}
                            />
                            {errors?.email && (
                              <sup className="text-danger">
                                {errors?.email?.message}
                              </sup>
                            )}
                          </Form.Group>

                          {/* Contact */}
                          <Form.Group className="input_group">
                            <Form.Label>Contact*</Form.Label>
                            <Controller
                              name="contact_no"
                              control={control}
                              rules={{
                                required: "Field is required",
                              }}
                              render={({ field }) => (
                                <PhoneInput
                                  country={"in"}
                                  {...field}
                                  className={classNames({
                                    "is-invalid": errors?.contact_no,
                                    "is-valid": getValues("contact_no"),
                                  })}
                                  onChange={(value) => field.onChange(value)}
                                  placeholder="Enter Mobile Number"
                                />
                              )}
                            />
                            {errors?.contact_no && (
                              <sup className="text-danger">
                                {errors?.contact_no?.message}
                              </sup>
                            )}
                          </Form.Group>

                          {/* Upload Product */}
                          <Form.Group className="input_group">
                            <Form.Label>Add Product*</Form.Label>

                            <Uploaded_img_holder />
                          </Form.Group>

                          <hr />

                          {/* Upload Notes */}
                          <div className="upload_note_div">
                            <p className="note_main_text">
                              UPLOAD YOUR DESIGN SAMPLE/S, SO THAT WE WILL GET
                              TO YOUR IDEA.
                            </p>
                            <p className="note_sub_text">
                              (Upload Preferences: 10 Mb Max PDF, AI, EPS, JPG,
                              PNG, JPEG)
                            </p>
                          </div>

                          {/* Radio */}
                          <Form.Group className="input_group">
                            <Form.Check
                              type="radio"
                              label="Add Custom Design"
                              name="custom_design"
                            />
                            <p className="radio_bottom_text">
                              (Add Logo / Artwork)
                            </p>
                          </Form.Group>

                          {/* Message */}
                          <Form.Group className="input_group">
                            <Form.Label>Add Special Requests</Form.Label>
                            <Form.Control
                              as="textarea"
                              placeholder="Type Your Message Here..."
                              {...register("message")}
                            />
                          </Form.Group>

                          {/* Submit */}
                          <div className="btn-holder">
                            <Purple_Btn
                              btnText={"Submit & Add To Cart"}
                              onClick={() => navigate("/luxury/cart")}
                            />
                          </div>
                        </Row>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Success_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        successText={"SEND REQUEST SUCCESSFULLY!"}
      />
    </section>
  );
};

export default Customisation_Form;
